import { render, staticRenderFns } from "./evaluacion-profesorjefe.vue?vue&type=template&id=e5d96cbe"
import script from "./evaluacion-profesorjefe.vue?vue&type=script&lang=js"
export * from "./evaluacion-profesorjefe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports